import Vue from 'vue';
import singleSpaVue from 'single-spa-vue';

import VueSocialSharing from 'vue-social-sharing';
import dayjs from 'dayjs';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import rir from './plugins/RirLib';
import 'windi.css';
import './assets/main.css';

Vue.use(VueSocialSharing);
axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? 'https://act.rosatom.city/api/'
  : '/api/';
Vue.prototype.$axios = axios;
require('dayjs/locale/ru');

dayjs.locale('ru');
dayjs.extend(require('dayjs/plugin/relativeTime'));
dayjs.extend(require('dayjs/plugin/quarterOfYear'));
dayjs.extend(require('dayjs/plugin/advancedFormat'));

Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false;

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(App, {
        props: {
          // single-spa props are available on the "this" object. Forward them to your component as needed.
          // https://single-spa.js.org/docs/building-applications#lifecyle-props
          // if you uncomment these, remember to add matching prop definitions for them in your App.vue file.
          /*
          name: this.name,
          mountParcel: this.mountParcel,
          singleSpa: this.singleSpa,
          */
        }
      });
    },
    router,
    store,
    $rir: rir
  }
});

export const { bootstrap } = vueLifecycles;
export const { mount } = vueLifecycles;
export const { unmount } = vueLifecycles;
